// -------------------------------
// DEDUCTION INTERFACES
// -------------------------------
export interface PendingDeduction {
    Name?: string;
    calculationType?: "percentage" | "amount";
    CalculatedUpon?: string;
    Percent?: string;
    Amount?: string;
    UnitOfCalculation?: string;
    Description?: string;
}

export interface PendingDeleteDeduction {
    awaitingName?: boolean;
}
export const startCreateDeductionFlow = (
    setPending: (data: PendingDeduction | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        setPending({ Name: nameFromIntent });
        pushAIChat("Is this deduction percentage based or absolute?");
        speak("Is this deduction percentage based or absolute?");
        return;
    }

    setPending({});
    pushAIChat("What should the deduction be called?");
    speak("What should the deduction be called?");
};
export const processPendingDeduction = (
    text: string,
    pending: PendingDeduction,
    setPending: (data: PendingDeduction | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {

    // STEP 1 — Name
    if (!pending.Name) {
        setPending({ ...pending, Name: text });
        pushAIChat("Is this deduction percentage based or absolute?");
        speak("Is this deduction percentage based or absolute?");
        return;
    }

    // STEP 2 — Calculation Type
    if (!pending.calculationType) {
        const type = text.toLowerCase().includes("percent")
            ? "percentage"
            : "amount";

        setPending({ ...pending, calculationType: type });

        if (type === "percentage") {
            pushAIChat("Which earning is this calculated upon?");
            speak("Which earning is this calculated upon?");
        } else {
            pushAIChat("What is the fixed amount?");
            speak("What is the fixed amount?");
        }
        return;
    }

    // STEP 3 — Calculated Upon
    if (pending.calculationType === "percentage" && !pending.CalculatedUpon) {
        setPending({ ...pending, CalculatedUpon: text });
        pushAIChat("What percentage should be applied?");
        speak("What percentage should be applied?");
        return;
    }

    // STEP 4 — Percent
    if (pending.calculationType === "percentage" && !pending.Percent) {
        setPending({ ...pending, Percent: text });
        pushAIChat("Any description for this deduction?");
        speak("Any description?");
        return;
    }

    // STEP 5 — Amount
    if (pending.calculationType === "amount" && !pending.Amount) {
        setPending({ ...pending, Amount: text });
        pushAIChat("Any description for this deduction?");
        speak("Any description?");
        return;
    }

    // STEP 6 — Description → FINAL
    if (!pending.Description) {
        const finalData = {
            ...pending,
            Description: text,
        };

        pushAIChat(`Creating deduction "${pending.Name}"...`);
        speak(`Creating deduction ${pending.Name}.`);

        window.dispatchEvent(
            new CustomEvent("ai-create-deduction", {
                detail: finalData,
            })
        );

        setPending(null);
    }
};
export const startDeleteDeductionFlow = (
    setPendingDelete: (data: PendingDeleteDeduction | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void,
    nameFromIntent?: string
) => {
    if (nameFromIntent) {
        pushAIChat(`Deleting deduction "${nameFromIntent}"...`);
        speak(`Deleting deduction ${nameFromIntent}.`);

        window.dispatchEvent(
            new CustomEvent("ai-delete-deduction", {
                detail: { name: nameFromIntent },
            })
        );
        return;
    }

    setPendingDelete({ awaitingName: true });
    pushAIChat("Which deduction would you like to delete?");
    speak("Which deduction would you like to delete?");
};
export const processPendingDeleteDeduction = (
    text: string,
    pending: PendingDeleteDeduction,
    setPendingDelete: (data: PendingDeleteDeduction | null) => void,
    pushAIChat: (msg: string) => void,
    speak: (msg: string) => void
) => {
    if (!pending.awaitingName) return;

    pushAIChat(`Deleting deduction "${text}"...`);
    speak(`Deleting deduction ${text}.`);

    window.dispatchEvent(
        new CustomEvent("ai-delete-deduction", {
            detail: { name: text },
        })
    );

    setPendingDelete(null);
};
